import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=52cc641c&scoped=true&"
import script from "./ShopDetail.vue?vue&type=script&lang=js&"
export * from "./ShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=52cc641c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc641c",
  null
  
)

export default component.exports